import type {
  DocumentData,
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  SnapshotOptions,
  WithFieldValue,
} from "firebase/firestore";

import { type SmileSimulation, SmileSimulationSchema } from "./schema.js";

export const smileSimulationConverter: FirestoreDataConverter<SmileSimulation> =
  {
    toFirestore(simulation: WithFieldValue<SmileSimulation>): DocumentData {
      return SmileSimulationSchema.parse(simulation);
    },
    fromFirestore(
      snapshot: QueryDocumentSnapshot<DocumentData, DocumentData>,
      options: SnapshotOptions,
    ): SmileSimulation {
      return SmileSimulationSchema.parse(snapshot.data(options));
    },
  };
